module.exports = __webpack_public_path__ + "static/media/eye.e279382d.svg";